import { idbItems } from "./indexedDB";

export const idbHelper = {
    setVipkok: async (value: any) => {
        await idbItems.set('vipkok', {
                        ptnId: value?.ptnId,
                        ptnName: value?.ptnName,
                        isUsed: value?.isUsed
                    });
    },
    getVipkok: async () => {
        return await idbItems.get('vipkok')
    },
    setAdAgreeYn: async (value: string) => {
        await idbItems.set('adAgreeYn', value);
    },
    getAdAgreeYn: async () => {
        return await idbItems.get('adAgreeYn')
    },
    setMarketingAgreeYn: async (value: string) => {
        await idbItems.set('marketingAgreeYn', value);
    },
    getMarketingAgreeYn: async () => {
        return await idbItems.get('marketingAgreeYn')
    },
    setUseVipkokYn: async (value: string) => {
        await idbItems.set('useVipkokYn', value);
    },
    getUseVipkokYn: async () => {
        return await idbItems.get('useVipkokYn')
    },
    setCardLevel: async (value: string) => {
        await idbItems.set('cardLevel', value);
    },
    getCardLevel: async () => {
        return await idbItems.get('cardLevel');
    },
    setLongTermCode: async (value: string) => {
        await idbItems.set('longTermCode', value);
    },
    getLongTermCode: async () => {
        return await idbItems.get('longTermCode');
    },
    setLongTermName: async (value: string) => {
        await idbItems.set('longTermName', value);
    },
    getLongTermName: async () => {
        return await idbItems.get('longTermName');
    },
    setYouthYn: async (value: string) => {
        await idbItems.set('youthYn', value);
    },
    getYouthYn: async () => {
        return await idbItems.get('youthYn');
    },
    setToken: async (value: string) => {
        await idbItems.set('token', value);
    },
    getToken: async () => {
        return await idbItems.get('token');
    },
    setEncKey: async (value: string) => {
        await idbItems.set('encKey', value);
    },
    getEncKey: async () => {
        return await idbItems.get('encKey');
    },
    setIsVIP: async (value: string) => {
        await idbItems.set('isVIP', value);
    },
    getIsVIP: async () => {
        return await idbItems.get('isVIP');
    },
    setTotalDiscount: async (value: string) => {
        await idbItems.set('totalDiscount', value);
    },
    getTotalDiscount: async () => {
        return await idbItems.get('totalDiscount');
    },
    setBarcode: async (value: string) => {
        await idbItems.set('barcode', value);
    },
    getBarcode: async () => {
        return await idbItems.get('barcode');
    },
    setTelcoCode: async (value: string) => {
        await idbItems.set('telcoCode', value);
    },
    getTelcoCode: async () => {
        return await idbItems.get('telcoCode');
    },
    setPlatform: async (value: string) => {
        await idbItems.set('platform', value);
    },
    getPlatform: async () => {
        return await idbItems.get('platform');
    },

}
